"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMember = exports.useAuthWithError = exports.useAuth = exports.Auth = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("./utils");
const getMember = ({ ctx, refetch, baseUrl = '' } = {}) => {
    if (ctx && ctx.req)
        return (0, utils_1.fetchMemberSSR)(ctx);
    const member = (0, utils_1.getMemberFromSession)();
    if (!refetch && member)
        return Promise.resolve(member);
    return (0, utils_1.fetchMember)(baseUrl).then((res) => {
        (0, utils_1.setMemberToSession)(res);
        return res;
    });
};
exports.getMember = getMember;
const Context = (0, react_1.createContext)({});
const Auth = ({ children, member: externalMember, baseUrl }) => {
    const [member, setMember] = (0, react_1.useState)(externalMember);
    const [error, setError] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!externalMember)
            getMember({ baseUrl })
                .then(setMember)
                .catch((err) => {
                setError(err);
                throw err;
            });
    }, [externalMember, baseUrl]);
    return (0, jsx_runtime_1.jsx)(Context.Provider, { value: { member, error }, children: children });
};
exports.Auth = Auth;
const useAuth = () => (0, react_1.useContext)(Context).member;
exports.useAuth = useAuth;
const useAuthWithError = () => (0, react_1.useContext)(Context);
exports.useAuthWithError = useAuthWithError;
